import firebase from 'firebase/app';
import React, { useCallback } from 'react';
import { FaGooglePlusSquare as BrandIcon } from 'react-icons/fa';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  button: {
    '&:hover': { background: '#A83627' },
    background: '#C94130',
    borderRadius: 4,
    color: '#FFF',
    composes: [
      'flex-columns',
      'flex-center',
      'items-center',
      'p12',
      'my6',
      'is-full-width',
    ],
    transition: 'background 0.3s',
  },
  icon: {
    composes: ['mr6', 'fs16'],
  },
  label: {
    composes: ['text-left'],
    width: 75,
  },
});

const GoogleButtonComponent = function GoogleButtonComponent() {
  const classes = useStyles();

  const signinHandler = useCallback(() => {
    const provider = new firebase.auth.GoogleAuthProvider();
    firebase.auth().signInWithRedirect(provider);
  }, []);

  return (
    <button className={classes.button} type="button" onClick={signinHandler}>
      <BrandIcon className={classes.icon} />
      <span className={classes.label}>Google</span>
    </button>
  );
};

GoogleButtonComponent.displayName = 'GoogleButtonComponent';

export default GoogleButtonComponent;
